import React from "react";
import styled from "styled-components";

import MuiDialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

import { Button } from "../../design-system";

type Props = {
  positiveAction: Function;
  negativeAction: Function;
  onCloseDialog: () => void;
  positiveText: string;
  negativeText: string;
  description: string;
  isOpen: boolean;
  title: string;
  ExtraButton?: any;
};

const TransitionComponent = (props: any) => <Slide direction="up" {...props} />;

const Panel = styled.div`
  background: var(--color-surface);
  color: var(--color-text);
  padding: var(--space-6);
  min-width: 360px;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  letter-spacing: -0.01em;
  color: var(--color-text);
  margin: 0;
`;

const Description = styled.p`
  font-family: var(--font-sans);
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
  color: var(--color-text-secondary);
  margin: 0;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  margin-top: var(--space-2);
`;

const onActionButtonClicked = (
  action: Function,
  onCloseDialog: Function
) => {
  action();
  onCloseDialog();
};

const CustomDialog = ({
  positiveAction,
  negativeAction,
  onCloseDialog,
  positiveText,
  negativeText,
  description,
  title,
  ExtraButton,
  isOpen,
}: Props) => (
  <MuiDialog
    TransitionComponent={TransitionComponent}
    onClose={onCloseDialog}
    open={isOpen}
    PaperProps={{
      style: {
        background: "var(--color-surface)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-xl)",
        border: "1px solid var(--color-border)",
        overflow: "hidden",
      },
    }}
    keepMounted
  >
    <Panel>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {ExtraButton}
      <Actions>
        <Button
          variant="ghost"
          onClick={() =>
            onActionButtonClicked(negativeAction, onCloseDialog)
          }
        >
          {negativeText}
        </Button>
        <Button
          variant="danger"
          onClick={() =>
            onActionButtonClicked(positiveAction, onCloseDialog)
          }
        >
          {positiveText}
        </Button>
      </Actions>
    </Panel>
  </MuiDialog>
);

export default CustomDialog;
